import React, { useEffect, useState } from "react";
import { fetchCandidatePreferences } from "src/services/Preferences/PreferenceServices";

const PreferenceComponents = ({ data, pageId }) => {
  const [allPreferences, setAllPreferences] = useState([]);
  const [preferences, setPreferences] = useState([]);

  const fetchPreferencesApiCall = async () => {
    var fetchPreferences = async () => {
      var response = await fetchCandidatePreferences(pageId);
      if (response.success) {
        setPreferences(response.body);
      }
    };
    fetchPreferences();
  };

  const fetchSelectedPreferencesApiCall = async () => {
    var all_prefrences = [];
    preferences.forEach((preference) => {
      var preference_obj = {
        priority: data[preference.id] ? data[preference.id] : 400,
        departmentName: preference.departmentName,
        id: preference.id,
        qualificationCategory: preference.qualificationCategory,
      };
      all_prefrences.push(preference_obj);
    });
    all_prefrences.sort((a, b) => a.priority - b.priority);
    setAllPreferences(all_prefrences);
  };

  useEffect(() => {
    fetchPreferencesApiCall();
  }, []);

  useEffect(() => {
    if (preferences.length) {
      fetchSelectedPreferencesApiCall();
    }
  }, [preferences]);

  return (
    <div>
      <div
        className="card-header text-white"
        style={{ backgroundColor: "#3C4B64" }}
      >
        <div className="d-flex align-items-center justify-content-between">
          <span className="mr-auto">Candidate Preference</span>
        </div>
      </div>
      <div className="table-responsive">
        <table className="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              {/* <th scope="col" style={{ width: "15%" }}>
                Index
              </th> */}
               <th scope="col" style={{ width: "50%" }}>
                Post
              </th>
              <th scope="col" style={{ width: "20%" }}>
                Place
              </th>
              <th scope="col" style={{ width: "15%" }}>
                Priority Number
              </th>
            </tr>
          </thead>
          <tbody>
            {allPreferences.map((preference, index) => (
              <tr key={index}>
                {/* <td>{preference.id}</td> */}
                <td>{preference.departmentName}</td>
                <td>{preference.qualificationCategory}</td>
                <td>{index + 1}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PreferenceComponents;
